// Code starts here

$(document).ready(function () {
    console.log('hello');
});

 var swiper = new Swiper("#is-best-seller", { 
    spaceBetween: 12, 
    breakpoints: { 
        0: { slidesPerView: 2, }, 
        992: { slidesPerView: 'auto', } 
    } 
});

//New Arrival
var swiper = new Swiper("#is-new-arrivals", { 
    spaceBetween: 12, 
    breakpoints: { 
        0: { slidesPerView: 2, }, 
        992: { slidesPerView: 'auto', } 
    } 
});

      //Testimonial
var swiper = new Swiper(".is-testimonial", {
    spaceBetween: 12,
    slidesPerView:1,
    speed: 500,
    effect: "creative",
    creativeEffect: {
        prev: {
            shadow: true,
            translate: [0, 0, -400],
        },
        next: {
            translate: ["100%", 0, 0],
        },
    },
    pagination: {
        el: '#testimonial-swiper-pagination',
        bulletActiveClass: 'is-active',
        bulletClass: 'component_swiper_bullet' ,
        clickable: true,
    },
    navigation: {
        nextEl: "#testimonial-swiper-next",
        prevEl: "#testimonial-swiper-prev",
    },
});


// Code ends here